import $http from './index.js';
export const GetUserPageList= (data)=>{
    return $http.post('api/User/GetUserPageList',data);
}
export const UpdateUserSatus= (data)=>{
    return $http.post('api/User/UpdateUserSatus',data);
}
export const DeleteUser= (data)=>{
    return $http.post('api/User/DeleteUser',data);
}